import { Box, Grid, Skeleton } from '@mui/material';

export const TwoFactorSubmitFormSkeleton = () => {
    return (
        <>
            <Box sx={{ mb: 3 }}>
                <Skeleton width="100%" height={60} sx={{ mx: 'auto' }} />
            </Box>
            <Grid container spacing={1}>
                <Grid size={12}>
                    <Skeleton width="100%" height={70} />
                    <Skeleton width="100%" height={50} />
                </Grid>
                <Grid size={12} sx={{ mt: 2 }}>
                    <Skeleton width="100%" height={50} />
                </Grid>
                <Grid size={12} sx={{ mt: 2 }}>
                    <Skeleton width="100%" height={50} />
                </Grid>
                <Grid size={12} sx={{ mt: 2 }}>
                    <Skeleton width="100%" height={50} />
                </Grid>
            </Grid>
        </>
    );
};
